(function(){
 if(window.__buildoraCartAdd)return;
 window.__buildoraCartAdd=true;
 function bdVia(){
  try{
    var el=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
    if(el&&typeof el.renderContents==='function'&&typeof el.getSectionsToRender==='function'){
      var lst=null;
      try{lst=el.getSectionsToRender();}catch(e){lst=null;}
      if(lst&&lst.length){
        var secs=[];var ok=true;
        for(var i=0;i<lst.length;i++){
          var s=lst[i]||{};
          var id=s.section||s.id;
          var target=s.selector?document.querySelector(s.selector):document.getElementById(s.id);
          if(!id||!target){ok=false;break;}
          secs.push(id);
        }
        if(ok)return{via:'dawn',el:el,sections:secs.join(',')};
      }
    }
    if(document.querySelector('cart-drawer-component')||document.querySelector('cart-items-component'))return{via:'horizon'};
  }catch(e){}
  return{via:null};
}
 var ESPERA=1200;
 var ESPERA_DE_SERIE=4000;
 var ESPERA_DEL_PRIMO=600;
 function raiz(){
  try{var r=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root;if(typeof r==='string'&&r.charAt(0)==='/')return r.charAt(r.length-1)==='/'?r:r+'/';}catch(e){}
  return '/';
 }
 function alCarrito(){window.location.href=raiz()+'cart';return 'cart';}
 function nativo(form){
  try{HTMLFormElement.prototype.submit.call(form);return 'nativo';}catch(e){}
  return alCarrito();
 }
 function suelta(form,boton){
  form.__bdAnadiendo=false;
  try{if(boton){boton.disabled=false;boton.removeAttribute('aria-busy');}}catch(e){}
 }
 function abierto(){
  try{
   var c=document.querySelector('cart-drawer-component')||document.querySelector('cart-items-component');
   if(!c)return false;
   return !!((c.closest&&c.closest('dialog[open],[open]'))||c.querySelector('dialog[open]'));
  }catch(e){return false;}
 }
 function vigila(c0){
  var hecho=false,avisar=null,obs=null;
  function fin(){if(hecho)return;hecho=true;try{if(obs)obs.disconnect();}catch(e){}if(avisar)avisar();}
  try{
   var c=c0||document.querySelector('cart-items-component')||document.querySelector('cart-drawer-component');
   if(c&&window.MutationObserver){
    obs=new MutationObserver(function(){setTimeout(fin,60);});
    obs.observe(c,{childList:true,subtree:true,characterData:true});
   }
  }catch(e){}
  return function(){
   return new Promise(function(listo){
    if(hecho){listo();return;}
    avisar=listo;
    setTimeout(fin,obs?ESPERA:0);
   });
  };
 }
 function abre(){
  try{
   var a=window.Shopify&&window.Shopify.actions;
   if(a&&typeof a.openCart==='function'){
    var p=a.openCart();
    if(p&&typeof p.then==='function')return p.then(function(){return true;},function(){return abierto();});
    return Promise.resolve(true);
   }
  }catch(e){}
  return Promise.resolve(abierto());
 }
 function primo(){
  try{
   var t=document.getElementsByTagName('*');
   for(var i=0;i<t.length;i++){
    var n=t[i].localName;
    if(n&&/.-cart-drawer-component$/.test(n)&&typeof t[i].open==='function'&&t[i].querySelector('dialog'))return t[i];
   }
  }catch(e){}
  return null;
 }
 function lineasDe(el){
  try{
   var t=el.getElementsByTagName('*');
   for(var i=0;i<t.length;i++){if(/-cart-items-component$/.test(t[i].localName||''))return t[i];}
  }catch(e){}
  return el;
 }
 function abiertoEn(el){try{return !!el.querySelector('dialog[open]');}catch(e){return false;}}
 function seAbre(el){
  return new Promise(function(listo){
   var hasta=Date.now()+ESPERA_DEL_PRIMO;
   (function mira(){
    if(abiertoEn(el)){listo(true);return;}
    if(Date.now()>hasta){listo(false);return;}
    setTimeout(mira,40);
   })();
  });
 }
 function otroCarrito(){
  try{
   if(document.querySelector('[id*="cart-drawer" i],[class*="cart-drawer" i],[id*="cartdrawer" i],[class*="cartdrawer" i],[id*="drawer-cart" i],[class*="drawer-cart" i],[id*="mini-cart" i],[class*="mini-cart" i],[id*="minicart" i],[class*="minicart" i],[id*="side-cart" i],[class*="side-cart" i],[id*="sidecart" i],[class*="sidecart" i],[id*="slide-cart" i],[class*="slide-cart" i],[id*="slidecart" i],[class*="slidecart" i],[id*="cart-sidebar" i],[class*="cart-sidebar" i],[id*="cart-flyout" i],[class*="cart-flyout" i],[id*="ajax-cart" i],[class*="ajax-cart" i],[id*="ajaxcart" i],[class*="ajaxcart" i],[id*="quick-cart" i],[class*="quick-cart" i],[id*="quickcart" i],[class*="quickcart" i],[id*="upcart" i],[class*="upcart" i],[id*="rebuy-cart" i],[class*="rebuy-cart" i]'))return true;
   var t=document.getElementsByTagName('*'),re=/cart-?drawer|drawer-?cart|mini-?cart|side-?cart|slide-?cart|cart-?sidebar|cart-?flyout|ajax-?cart|quick-?cart|upcart|rebuy-?cart/;
   for(var i=0;i<t.length;i++){
    var n=t[i].localName;
    if(n&&n.indexOf('-')>0&&n!=='buildora-cart-drawer'&&re.test(n))return true;
   }
   return false;
  }catch(e){return true;}
 }
 function deSerie(form){
  var u,o;
  try{
   var h=form.querySelector('[data-bd-carrito]')||form.closest('[data-bd-carrito]');
   u=h&&h.getAttribute('data-bd-carrito');
   if(!u||otroCarrito())return null;
   o={js:h.getAttribute('data-bd-carrito-js'),css:h.getAttribute('data-bd-carrito-css'),raiz:raiz(),idioma:h.getAttribute('data-bd-carrito-idioma')};
  }catch(e){return null;}
  var cargador=new Promise(function(listo){
   function ya(){
    var c=null;
    try{c=window.BuildoraCarritoDeSerie;if(c&&typeof c.preparar==='function')c.preparar(o);}catch(e){}
    listo(c&&typeof c.abrir==='function'?c:null);
   }
   try{
    if(window.BuildoraCarritoDeSerie){ya();return;}
    var s=document.createElement('script');
    s.src=u;
    s.onload=ya;
    s.onerror=function(){listo(null);};
    document.head.appendChild(s);
   }catch(e){listo(null);}
  });
  return function(){
   return new Promise(function(listo){
    setTimeout(function(){listo(false);},ESPERA_DE_SERIE);
    cargador.then(function(c){
     if(!c){listo(false);return;}
     try{c.abrir(o).then(function(si){listo(si===true);},function(){listo(false);});}catch(e){listo(false);}
    });
   });
  };
 }
 function anade(form,boton){
  var via,fd,post,repintado=null,serie=null;
  try{
   via=bdVia();
   if(!via.via){var pr=primo();if(pr)via={via:'primo',el:pr};}
   fd=new FormData(form);
   if(!fd.get('id'))return nativo(form);
   if(via.via==='dawn'){fd.append('sections',via.sections);fd.append('sections_url',window.location.pathname);}
   var accion=String(form.getAttribute('action')||'').split('?')[0].replace(/\/+$/,'').replace(/\.js$/,'');
   if(!/\/cart\/add$/.test(accion))return nativo(form);
   form.__bdAnadiendo=true;
   if(boton){boton.setAttribute('aria-busy','true');boton.disabled=true;}
   if(via.via==='horizon')repintado=vigila();
   if(via.via==='primo')repintado=vigila(lineasDe(via.el));
   post=fetch(accion+'.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd});
  }catch(e){suelta(form,boton);return nativo(form);}
  function cuenta(fallo){
   return fetch(raiz()+'cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){return r.json();})
    .then(function(j){
     var n=j&&typeof j.item_count==='number'?j.item_count:null;
     if(n===null)return{detail:{didError:!!fallo}};
     return{cart:{totalQuantity:n},detail:{itemCount:n,didError:!!fallo}};
    },function(){return{detail:{didError:!!fallo}};});
  }
  var senal=post.then(function(r){return cuenta(!(r&&r.ok));},function(){return cuenta(true);});
  try{
   var ev=new CustomEvent('shopify:cart:lines-update',{bubbles:true});
   ev.action='add';
   ev.promise=senal;
   document.dispatchEvent(ev);
  }catch(e){}
  if(!via.via)serie=deSerie(form);
  return post.then(function(res){
   if(!res.ok){suelta(form,boton);return nativo(form);}
   return res.json().then(function(j){return j;},function(){return null;}).then(function(json){
    if(via.via==='dawn'&&json&&json.sections){
     try{
      try{via.el.classList.remove('is-empty');}catch(e){}
      via.el.renderContents(json);
      suelta(form,boton);
      return 'dawn';
     }catch(e){return alCarrito();}
    }
    if(via.via==='horizon'){
     return senal.then(function(){return repintado?repintado():null;}).then(abre).then(function(ok){
      if(ok||abierto()){suelta(form,boton);return 'horizon';}
      return alCarrito();
     },function(){return alCarrito();});
    }
    if(via.via==='primo'){
     return senal.then(function(){return repintado?repintado():null;}).then(function(){
      if(abiertoEn(via.el))return true;
      try{via.el.open();}catch(e){}
      return seAbre(via.el);
     }).then(function(ok){
      if(ok){suelta(form,boton);return 'primo';}
      return alCarrito();
     },function(){return alCarrito();});
    }
    if(!serie)return alCarrito();
    return serie().then(function(si){
     if(si){suelta(form,boton);return 'buildora';}
     return alCarrito();
    },function(){return alCarrito();});
   });
  },function(){return alCarrito();}).then(null,function(){return alCarrito();});
 }
 var ultimo=null,cuando=0;
 window.addEventListener('click',function(e){
  try{
   var b=e.target&&e.target.closest&&e.target.closest('button[type="submit"],input[type="submit"]');
   if(b&&b.form){ultimo=b;cuando=Date.now();}
  }catch(x){}
 },true);
 window.addEventListener('submit',function(e){
  try{
   var form=e.target;
   if(e.defaultPrevented||!form||form.nodeName!=='FORM'||!form.matches||!form.matches('.pl-hero form.pl-form'))return;
   if(form.closest('[data-buildora-cart-ignore]'))return;
   var boton=e.submitter||(ultimo&&ultimo.form===form&&Date.now()-cuando<1500?ultimo:null);
   if(boton&&!(boton.name==='add'&&/(^|\s)pl-cta(\s|$)/.test(String(boton.className))))return;
   if(!window.fetch||!window.FormData||!window.Promise)return;
   e.preventDefault();
   if(form.__bdAnadiendo)return;
   if(!boton)boton=form.querySelector('button[name="add"]');
   var r=anade(form,boton);
   if(r&&typeof r.then==='function')r.then(null,function(){});
  }catch(x){}
 },false);
 window.addEventListener('submit',function(e){
  try{
   var f=e.target,b=e.submitter;
   if(!f||!b||b.name!=='return_to'||!f.matches||!f.matches('.pl-hero form.pl-form'))return;
   if(f.hasAttribute('data-buildora-cart-ignore'))return;
   f.setAttribute('data-buildora-cart-ignore','');
   setTimeout(function(){try{f.removeAttribute('data-buildora-cart-ignore');}catch(x){}},0);
  }catch(x){}
 },true);
 window.addEventListener('keydown',function(e){
  try{
   if(e.key!=='Escape'||!window.BuildoraCart||typeof window.BuildoraCart.close!=='function')return;
   var el=document.querySelector('buildora-cart-drawer');
   var d=el&&el.shadowRoot?el.shadowRoot.querySelector('dialog'):null;
   if(d&&d.open)window.BuildoraCart.close();
  }catch(x){}
 },true);
 window.addEventListener('pageshow',function(e){
  if(!e||!e.persisted)return;
  try{
   var fs=document.querySelectorAll('.pl-hero form.pl-form');
   for(var i=0;i<fs.length;i++)suelta(fs[i],fs[i].querySelector('button[name="add"]'));
  }catch(x){}
 });
})();